export const getPercentNumber = (number: number) => {
  return parseFloat((number * 100).toPrecision(12).toString())
}

const formatMoneyRaw = (amount: number, fixed: number = 2) => {
  try {
    if (isNaN(amount)) {
      console.log('Not a valid number', amount);
      return String(amount);
    }
    
    // Format with commas as thousand separators and periods as decimal separators
    if (fixed !== undefined) {
      // Convert to fixed decimal places
      const amountWithDecimals = parseFloat(amount.toString()).toFixed(fixed);
      // Split by decimal point
      const parts = amountWithDecimals.split('.');
      // Format integer part with commas as thousand separators
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // Join with period as decimal separator
      return parts.join('.');
    }
    
    // For cases without fixed decimal places, manually format
    const parts = amount.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const result = parts.join('.')
    return result
  } catch (error) {
    console.log({ error, amount });
    return String(amount);
  }
}

export const isInWorkingHour = () => {
  const now = new Date();
  const day = now.getDay(); // local time
  if (day === 0 || day === 6) return false;

  const hour = now.getHours();
  const minute = now.getMinutes();
  const time = hour * 100 + minute;

  return (time >= 900 && time < 1130) || (time >= 1300 && time < 1445);
}

export const formatStockPrice = (amount: number | string, fixed: number = 2) => {
  // Convert string to number if needed
  const numericAmount = typeof amount === 'string' ? 
    (amount === '' ? 0 : parseFloat(amount) || 0) : 
    (amount || 0);
    
  let result = formatMoneyRaw(numericAmount, fixed);
  if (result.endsWith('.')) {
    result = result.slice(0, -1);
  }
  return result
}

export const formatCurrencyRaw = (amount: number | string, fixed: number = 2) => {
  // Convert string to number if needed
  const numericAmount = typeof amount === 'string' ? 
    (amount === '' ? 0 : parseFloat(amount) || 0) : 
    (amount || 0);
    
  let result = formatMoneyRaw(numericAmount, fixed);
  while (result.includes('.') && result.endsWith('0')) {
    result = result.slice(0, -1);
  }
  if (result.endsWith('.')) {
    result = result.slice(0, -1);
  }
  return result
}

export const formatCurrency = (amount: number, fixed: number = 0) => {
  return formatCurrencyRaw(Math.round(amount), fixed);
}

export const removeVietnameseTones = (str: string) => {
  try {
    let newStr = str.toString()
    newStr = newStr.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    newStr = newStr.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    newStr = newStr.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    newStr = newStr.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    newStr = newStr.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    newStr = newStr.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    newStr = newStr.replace(/đ/g, "d");
    newStr = newStr.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    newStr = newStr.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    newStr = newStr.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    newStr = newStr.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    newStr = newStr.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    newStr = newStr.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    newStr = newStr.replace(/Đ/g, "D");
    // Some system encode vietnamese combining accent as individual utf-8 characters
    // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
    newStr = newStr.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
    newStr = newStr.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
    // Remove extra spaces
    // Bỏ các khoảng trắng liền nhau
    newStr = newStr.replace(/ + /g, " ");
    newStr = newStr.trim();
    // Remove punctuations
    // Bỏ dấu câu, kí tự đặc biệt
    newStr = newStr.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
    return newStr;
  } catch (error) {
    return str
  }
}


const DIGIT_HASH = 1000000

const string2Bin = (str: string) => {
  let result = [];
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    result.push(charCode & 0xFF)
    result.push((charCode & 0xFF00) >> 8)
  }
  return result;
}

export const getStableHash = (s: string) => {
  try {
    var hash = 0;
    var bytes = string2Bin(s)
    for (var i = 0; i < bytes.length; i++) {
      hash += bytes[i];
      hash += (hash << 10);
      hash ^= (hash >>> 6);
    }
    hash += (hash << 3);
    hash ^= (hash >>> 11);
    hash += (hash << 15);
    // Return a string, not a number
    return String(Math.abs((hash >>> 0) % DIGIT_HASH)).padStart(6, '0');
  } catch (error) {
    console.log({error})
    // Return 0 instead of '000000' string
    return '000000';
  }
}

/**
 * Copy text to clipboard with iOS WebView compatibility
 * @param value - text to copy
 * @param onSuccess - callback function on successful copy
 * @param onError - callback function on error
 */
export const copyToClipboard = (value: string, onSuccess?: () => void, onError?: () => void) => {
  // First try the modern clipboard API
  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    navigator.clipboard.writeText(value)
      .then(() => {
        if (onSuccess) onSuccess();
        return;
      })
      .catch(() => {
        // If clipboard API fails, fall back to other methods
        copyTextFallback(value, onSuccess, onError);
      });
    return;
  }
  
  // Fall back to older method for iOS WebView
  copyTextFallback(value, onSuccess, onError);
};

/**
 * Fallback method for copying text in iOS WebView
 * @param text - text to copy
 * @param onSuccess - callback function on successful copy
 * @param onError - callback function on error
 */
const copyTextFallback = (text: string, onSuccess?: () => void, onError?: () => void) => {
  try {
    // Create a temporary textarea element
    const textArea = document.createElement('textarea');
    textArea.value = text;
    
    // Make the textarea out of viewport
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    
    // iOS specific handling
    textArea.contentEditable = 'true';
    textArea.readOnly = false;
    
    // Select the text
    textArea.focus();
    textArea.select();
    
    // Create range and selection
    const range = document.createRange();
    range.selectNodeContents(textArea);
    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, text.length);
    }
    
    // Copy the text
    const successful = document.execCommand('copy');
    
    // Clean up
    document.body.removeChild(textArea);
    
    if (successful) {
      if (onSuccess) onSuccess();
    } else {
      if (onError) onError();
    }
  } catch (err) {
    console.error('Fallback: Could not copy text: ', err);
    if (onError) onError();
  }
};
